import { Button, Card } from "../../shared/ui/index.js";
import { useToast } from "../../shared/toast.js";
import { useUpdateLead, type Lead, type LeadStatus } from "./leads.api.js";

const STATUS_LABEL: Record<LeadStatus, string> = {
  new: "Nouvelle",
  contacted: "Contactée",
  quoted: "Devis envoyé",
  won: "Gagnée",
  lost: "Perdue",
};

export function LeadCard({ lead, onConvert }: { lead: Lead; onConvert: () => void }) {
  const update = useUpdateLead();
  const toast = useToast();

  return (
    <Card className="!p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="min-w-0">
          <p className="truncate font-medium text-stone-900">{lead.contactName}</p>
          <p className="truncate text-sm text-stone-500">
            {lead.email}
            {lead.phone ? ` · ${lead.phone}` : ""}
          </p>
        </div>
        <div className="flex items-center gap-2">
          <select
            value={lead.status}
            onChange={(e) =>
              update.mutate({ id: lead.id, patch: { status: e.target.value as LeadStatus } })
            }
            className="rounded-lg border border-stone-200 px-2 py-1 text-xs"
          >
            {(Object.keys(STATUS_LABEL) as LeadStatus[]).map((s) => (
              <option key={s} value={s}>
                {STATUS_LABEL[s]}
              </option>
            ))}
          </select>
          {lead.convertedUserId ? (
            <span className="text-xs text-emerald-600">compte créé</span>
          ) : (
            <Button className="!px-3 !py-1 !text-xs" onClick={onConvert}>
              Convertir
            </Button>
          )}
        </div>
      </div>
      {lead.message && <p className="mt-2 text-sm text-stone-600">{lead.message}</p>}
      <textarea
        defaultValue={lead.adminNotes ?? ""}
        placeholder="Notes internes…"
        onBlur={(e) => {
          if (e.target.value !== (lead.adminNotes ?? "")) {
            update.mutate(
              { id: lead.id, patch: { adminNotes: e.target.value } },
              { onSuccess: () => toast("Note enregistrée") },
            );
          }
        }}
        className="mt-2 w-full rounded-lg border border-stone-200 p-2 text-xs"
        rows={2}
      />
    </Card>
  );
}
